import React from 'react';
import './ContentLoading.css';

const ContentLoading = () => (
  <div>Loading</div>
);

export default ContentLoading;
